module.exports = __webpack_public_path__ + "static/josh-7949219f5e81c47890ee382674403b02.jpg";